import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#0E4F26"
      d="M4 21c-.55 0-1.021-.196-1.413-.588A1.922 1.922 0 0 1 2 19V8c0-.55.196-1.021.588-1.413A1.922 1.922 0 0 1 4 6h4V4c0-.55.196-1.021.588-1.413A1.922 1.922 0 0 1 10 2h4c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v2h4c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v11c0 .55-.196 1.021-.588 1.413A1.922 1.922 0 0 1 20 21H4Zm6-15h4V4h-4v2Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
